/**
 * Contact Page Scroll Behavior
 *
 * This script handles the custom scroll behavior for the contact page.
 * When the user scrolls the right column content and reaches the bottom,
 * the scroll behavior transitions to normal page scrolling.
 */

document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.querySelector("[data-scroll-container]");

  if (!scrollContainer) return;

  let isScrollingContainer = false;

  // Handle mouse wheel events
  scrollContainer.addEventListener(
    "wheel",
    function (e) {
      if (!isScrollingContainer) return;

      const isAtTop = scrollContainer.scrollTop === 0;
      const isAtBottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 1;

      // Allow default behavior (page scroll) when:
      // - Scrolling up at the top of the container
      // - Scrolling down at the bottom of the container
      if ((e.deltaY < 0 && isAtTop) || (e.deltaY > 0 && isAtBottom)) {
        return;
      }

      // Otherwise, prevent default and scroll the container
      e.preventDefault();
      scrollContainer.scrollTop += e.deltaY;
    },
    { passive: false },
  );

  // Handle touch scroll
  let touchStartY = 0;

  scrollContainer.addEventListener("touchstart", function (e) {
    touchStartY = e.touches[0].clientY;
    isScrollingContainer = true;
  });

  scrollContainer.addEventListener(
    "touchmove",
    function (e) {
      if (!isScrollingContainer) return;

      const touchCurrentY = e.touches[0].clientY;
      const diff = touchStartY - touchCurrentY;

      const isAtTop = scrollContainer.scrollTop === 0;
      const isAtBottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 1;

      // Allow default behavior when reaching scroll boundaries
      if ((diff < 0 && isAtTop) || (diff > 0 && isAtBottom)) {
        isScrollingContainer = false;
        return;
      }

      // Scroll the container
      e.preventDefault();
      scrollContainer.scrollTop += diff;
    },
    { passive: false },
  );

  scrollContainer.addEventListener("touchend", function () {
    isScrollingContainer = false;
  });

  // Handle focus to enable container scrolling
  scrollContainer.addEventListener("mouseenter", function () {
    isScrollingContainer = true;
  });

  scrollContainer.addEventListener("mouseleave", function () {
    isScrollingContainer = false;
  });
});
